import * as yup from "yup";
import { t } from "@/helpers/i18n";

// Długość pól nazw w bazie (Clients.Name, Distributors.Name: nvarchar(500))
export const nameMaxLength = 500;
// Domyślne zasady haseł ASP.NET Identity używane przez API panelu (sprawdza znaki ASCII)
export const passwordMinLength = 6;

export function requiredText(maxLength?: number) {
    const schema = yup.string().trim().required(t("validation.required"));
    return maxLength ? schema.max(maxLength, t("validation.maxLength", { max: maxLength })) : schema;
}

export function optionalText(maxLength?: number) {
    const schema = yup.string().trim();
    return maxLength ? schema.max(maxLength, t("validation.maxLength", { max: maxLength })) : schema;
}

// Hasła sprawdzamy bez przycinania spacji - są częścią hasła
export function requiredPassword() {
    return yup.string().required(t("validation.required"));
}

export function requiredEmail() {
    return yup.string().trim().required(t("validation.required")).email(t("validation.email"));
}

export function requiredChoice() {
    return yup.mixed().test("required", t("validation.required"),
        value => value !== undefined && value !== null && value !== "");
}

export function newPassword() {
    return yup.string()
        .required(t("validation.required"))
        .min(passwordMinLength, t("validation.passwordMin", { min: passwordMinLength }))
        .matches(/[a-z]/, t("validation.passwordLower"))
        .matches(/[A-Z]/, t("validation.passwordUpper"))
        .matches(/[0-9]/, t("validation.passwordDigit"))
        .matches(/[^a-zA-Z0-9]/, t("validation.passwordSpecial"));
}

export function passwordConfirmation(passwordField: string) {
    return yup.string()
        .required(t("validation.required"))
        .oneOf([yup.ref(passwordField)], t("validation.passwordConfirm"));
}
